/**
 * Created by t.baldauf on 10.11.2016.
 */

$(document).ready(function(){
    $('.collapse-submenu .icon-submenu-wrapper').click(function(e){
        e.preventDefault();
        $(this).parent('.collapse-submenu').toggleClass( "active" )
    });
    $('.collapse-sub-submenu .icon-sub-submenu-wrapper').click(function(e){
        e.preventDefault();
        $(this).parent('.collapse-sub-submenu').toggleClass( "active" )
    });
    $('#mobile-menu-button>span').click(function(){
        if($('#mobilewrapper').hasClass('active')){
            $('#mobile-menu-button').find('.glyphicon').removeClass('glyphicon-remove-sign');
            $('#mobile-menu-button').find('.glyphicon').addClass('glyphicon-menu-hamburger');
            $('#mobilewrapper').removeClass('active');
            $('#mobilewrapper').hide();

        }else{
            $('#mobile-menu-button').find('.glyphicon').addClass('glyphicon-remove-sign');
            $('#mobile-menu-button').find('.glyphicon').removeClass('glyphicon-menu-hamburger');
            $('#mobilewrapper').addClass('active');
            $('#mobilewrapper').show();

        }
    });

    $(document).trigger('scroll');
});

$(document).scroll(function() {
    var y = $(this).scrollTop();
    if (y > 100) {
        $('.navbar-top').addClass('small22');
        $('#mobilewrapper').addClass('mobile-up');
        // if($('#searchbox-mobile').css('margin-top')== '200px'){
        //     $('#searchbox-mobile').css({
        //         "margin-top":"116px"
        //     });
        // }
    } else {
        $('.navbar-top').removeClass('small22');
        $('#mobilewrapper').removeClass('mobile-up');
        // if($('#searchbox-mobile').css('margin-top')== '116px'){
        //     $('#searchbox-mobile').css({
        //         "margin-top":"200px"
        //     });
        // }
    }
});
